import { useNavigate } from "react-router-dom";
import useCartContext from "../../../hooks/useCartContext";
import useWishlistContext from "../../../hooks/useWishlistContext";
import GiftCard from "../../Home/shared/GiftCard";
import Loader from "../../Ui/Loader";
import InfoMessage from "../../Ui/InfoMessage";
import "../Design/index.css";

const WishlistItem = () => {
  const navigate = useNavigate();

  const { addToCart } = useCartContext();
  const { wishlist, isWishlistPending, wishlistError, removeFromWishlist } =
    useWishlistContext();

  return (
    <>
      <div
        className="account-heading d-flex align-items-center"
        data-aos="fade-up"
        data-aos-delay="2500"
        data-aos-duration="1000"
      >
        <h5 className="mb-5">My Favorites</h5>
      </div>
      <div className="col-xxl-9 col-xl-8 col-lg-8 col-md-12 ">
        <div className="row justify-content-center">
          {isWishlistPending ? (
            <Loader />
          ) : wishlistError ? (
            <InfoMessage text={wishlistError} />
          ) : !wishlist?.length ? (
            <InfoMessage text="No gifts to show" />
          ) : (
            wishlist.map((item, index) => {
              return (
                <GiftCard
                  key={item?._id}
                  image={item?.item?.image}
                  inbuildImage={item?.item?.image}
                  title={
                    item?.item?.productDetails?.nameEn || item?.item?.title
                  }
                  category={item?.item?.productDetails?.categoryNameEn}
                  price={`${item?.item.priceInSAR?.toFixed(2)}`}
                  onClick={() => navigate(`/gifts/bitaqaty/${item?.item?._id}`)}
                  addToCart={() =>
                    item?.item?.productDetails?.productTag === "bitaqty"
                      ? addToCart(item?.item?._id)
                      : addToCart(item?.item?._id, false, "Binance")
                  }
                  removeFromWishlist={() => removeFromWishlist(item?.item?._id)}
                  isInWishlist
                  smallGrid={true}
                />
              );
            })
          )}
        </div>
      </div>
    </>
  );
};
export default WishlistItem;
